import { render } from "./voyantsocket.vue?vue&type=template&id=b30aba5c&scoped=true"
import script from "./voyantsocket.vue?vue&type=script&lang=js"
export * from "./voyantsocket.vue?vue&type=script&lang=js"

import "./voyantsocket.vue?vue&type=style&index=0&id=b30aba5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b30aba5c"]])

export default __exports__